<template>
  <dl class="vcr-quote-meta-info__wrapper">
    <dt>{{ i18n.t('/Vcr/Meta Info/Delivery Date Label') }}</dt>
    <dd>{{ deliveryDate }}</dd>

    <dt>Status</dt>
    <dd class="vcr-quote-meta-info__status">{{ quoteStatusLabel }}</dd>

    <dt>{{ i18n.t('/Vcr/Meta Info/Offer Valid Label') }}</dt>
    <dd>{{ expireDate }}</dd>

    <dt>{{ i18n.t('/Vcr/Meta Info/Quote Number Label') }}</dt>
    <dd data-qa="vcr-quote-number">{{ $route.params.quoteId }}</dd>
  </dl>
</template>

<script>
import moment from 'moment'
import { getStatus } from '@/helpers/statusHelper'

export default {
  data() {
    return {
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
    }
  },
  computed: {
    deliveryDate() {
      return moment(this.$store.getters['quote/deliveryDate']).format('L')
    },
    expireDate() {
      return moment(this.$store.getters['quote/expireDate']).format('L')
    },
    quoteStatusLabel() {
      return getStatus(this.$store.getters['quote/status'])
    },
  },
}
</script>

<style lang="scss" scoped>
.vcr-quote-meta-info {
  &__wrapper {
    display: flex;
    flex-wrap: wrap;

    > dt,
    dd {
      flex-basis: 25%;
    }
  }

  &__status {
    text-transform: uppercase;
  }
}
</style>
